/**
 * Teslimat bölgesi çubuğu + koleksiyon ürün filtresi.
 *
 * NE YAPAR
 *  1. Sayfanın üstünde müşterinin teslimat adresini seçtiği bir çubuk gösterir.
 *  2. Adres seçilince listelenen ürünleri süzer: o adrese GÖNDERİLEMEYEN
 *     ürünler gizlenir. Müşteri sipariş veremeyeceği bir ürünü görmemeli.
 *  3. Kurye ile aynı gün gidebilen ürünlerin görselinin altında, başlığın
 *     üstünde yeşil "Aynı Gün Teslimat" rozeti gösterir.
 *
 * KURAL TABLOSU (ürünün teslimat modu × bayinin o adrese çıkıp çıkmaması)
 *
 *   mod                | bayi çıkıyor        | bayi çıkmıyor
 *   -------------------|---------------------|------------------
 *   cargo_only         | görünür, rozet yok  | görünür, rozet yok
 *   courier_and_cargo  | görünür + ROZET     | görünür, rozet yok
 *   courier_only       | görünür + ROZET     | GİZLENİR
 *
 * Yalnızca "courier_only" ürünler gizlenir; diğerleri kargoyla da gidebildiği
 * için bölge dışında da satılabilir.
 *
 * ADRES DURUMU AGT WIDGET'IYLA ORTAK
 * Ürün sayfasındaki teslimat widget'ıyla aynı localStorage anahtarlarını
 * kullanır ve aynı olayı (localDeliveryLocationChanged) hem yayar hem dinler.
 * Böylece müşteri adresini nerede değiştirirse değiştirsin iki taraf da
 * aynı şeyi gösterir.
 */
(function () {
  if (window.__tmDeliveryBar) return;
  window.__tmDeliveryBar = true;

  var PROXY = "/apps/local-delivery";

  var STORE_CITY = "local_delivery_city";
  var STORE_DISTRICT = "local_delivery_district";
  var STORE_NEIGHBORHOOD = "local_delivery_neighborhood";

  // Sitenin adres ekranındaki "Standart Kargo ile Devam Et" düğmesi ilçeyi
  // bu değerle kaydediyor (bkz. AGT widget'ında queryFullLocation("İstanbul",
  // "Kargo", "Kargo")). Gerçek bir ilçe değil, "bölge dışındayım" işareti -
  // ekranda ilçe adı gibi göstermemek ve boşuna bölge sorgusu atmamak için
  // ayrıca tanıyoruz.
  var OUTSIDE = "Kargo";

  var state = {
    city: "",
    district: "",
    neighborhood: "",
    filterOn: true,
    // { "Bayi Adı": true|false } - bu adrese kurye çıkıyor mu
    vendorCoverage: {},
    products: []
  };

  var els = {};

  // ---------------------------------------------------------------- yardımcı

  function read(key) {
    try {
      return localStorage.getItem(key) || "";
    } catch (e) {
      return "";
    }
  }

  function getJson(path, params) {
    var qs = Object.keys(params)
      .filter(function (k) {
        return params[k] !== "" && params[k] != null;
      })
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      })
      .join("&");

    return fetch(PROXY + path + (qs ? "?" + qs : ""), { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function hasAddress() {
    return Boolean(state.city && state.district);
  }

  function isOutside() {
    return state.district === OUTSIDE || state.neighborhood === OUTSIDE;
  }

  // ------------------------------------------------------------ ürün kartları

  /**
   * Sayfadaki ürün kartlarını toplar.
   *
   * Kartlar Liquid tarafında `.tm-pd` işaretçisiyle etiketleniyor
   * (bkz. snippets/product-card-grid.liquid ve product-card-list.liquid);
   * bayi ve teslimat modu oradan okunuyor. Gizlerken kartın kendisini değil,
   * ızgara hücresini gizliyoruz - aksi halde boş hücreler kalıp düzen bozulur.
   */
  function collectProducts() {
    state.products = Array.prototype.map.call(document.querySelectorAll(".tm-pd"), function (marker) {
      return {
        vendor: (marker.getAttribute("data-tm-vendor") || "").trim(),
        mode: (marker.getAttribute("data-tm-mode") || "courier_and_cargo").trim(),
        cell: marker.closest(".gitem, .lv_item") || marker.closest(".grid_bx") || marker.parentElement,
        badge: null
      };
    });

    state.products.forEach(function (item) {
      if (!item.cell) return;
      item.badge = item.cell.querySelector(".tm-sameday");
    });
  }

  /** Sayfadaki farklı bayiler - bölge sorgusu bayi başına bir kez atılır. */
  function vendorsOnPage() {
    var seen = [];
    state.products.forEach(function (item) {
      if (item.vendor && seen.indexOf(item.vendor) === -1) seen.push(item.vendor);
    });
    return seen;
  }

  /**
   * Her bayi için "bu adrese kurye çıkıyor mu" sorar.
   * Bölge dışı seçildiyse hiç sormaya gerek yok - hiçbiri çıkmıyor.
   */
  function loadVendorCoverage() {
    state.vendorCoverage = {};

    if (!hasAddress() || isOutside()) {
      return Promise.resolve();
    }

    var vendors = vendorsOnPage();

    return Promise.all(
      vendors.map(function (vendor) {
        return coverageFor(vendor).then(function (covered) {
          state.vendorCoverage[vendor] = covered;
        });
      })
    );
  }

  /**
   * Bir bayi bu adrese çıkıyor mu?
   *
   * Mahalle seçildiyse check-location, seçilmediyse check-district
   * kullanılıyor. Bu ayrım önemli: check-location'daki joker BÖLGE TARAFINDA
   * çalışıyor ("bu bayi tüm mahallelere çıkıyor"), sorgu tarafında değil.
   * Mahalle yerine "*" göndermek, mahalle bazlı bölge tanımlamış bir bayide
   * hiçbir zaman eşleşmez ve ürünleri haksız yere gizlerdik. İlçe sorusunun
   * doğru muhatabı check-district.
   */
  function coverageFor(vendor) {
    if (state.neighborhood) {
      return getJson("/check-location", {
        city: state.city,
        district: state.district,
        neighborhood: state.neighborhood,
        vendorName: vendor
      }).then(function (data) {
        return Boolean(data && data.matched);
      });
    }

    return getJson("/check-district", {
      city: state.city,
      district: state.district,
      vendorName: vendor
    }).then(function (data) {
      return Boolean(data && data.active);
    });
  }

  function vendorCovers(vendor) {
    return Boolean(state.vendorCoverage[vendor]);
  }

  /** Ürün bu adrese gönderilebilir mi? */
  function deliverable(item) {
    if (item.mode === "courier_only") {
      return vendorCovers(item.vendor);
    }
    return true;
  }

  /** Aynı gün rozeti gösterilsin mi? */
  function sameDay(item) {
    return item.mode !== "cargo_only" && vendorCovers(item.vendor);
  }

  function applyToProducts() {
    state.products.forEach(function (item) {
      if (!item.cell) return;

      var canDeliver = !hasAddress() || deliverable(item);
      var hide = state.filterOn && hasAddress() && !canDeliver;

      item.cell.classList.toggle("tm-hidden-product", hide);

      if (item.badge) {
        // Sınıf değil `hidden` özniteliği: bu CSS dosyası yalnızca section'ın
        // olduğu sayfada yükleniyor, rozet ise tüm koleksiyonların kartlarında
        // basılı. Gizliliği tarayıcının kendi kuralına bırakmak, section'sız
        // sayfalarda rozetin düz metin olarak sızmasını engelliyor.
        item.badge.hidden = !(hasAddress() && sameDay(item));
      }
    });

  }

  // ------------------------------------------------------------------- çubuk

  function renderBar() {
    if (!els.root) return;

    els.root.setAttribute("data-has-address", hasAddress() ? "true" : "false");

    if (!hasAddress()) {
      els.root.setAttribute("data-state", "empty");
      els.address.textContent = els.root.getAttribute("data-empty-title") || "Nereye teslim edilecek?";
      els.note.textContent = els.root.getAttribute("data-empty-note") || "Adresinizi seçin, size ulaşabilen ürünleri gösterelim.";
      els.change.textContent = "Adres Seç";
      els.label.textContent = "Teslimat Adresi";
      return;
    }

    var anyCourier = Object.keys(state.vendorCoverage).some(function (v) {
      return state.vendorCoverage[v];
    });

    els.label.textContent = "Teslimat Adresi";
    els.change.textContent = "Değiştir";

    if (isOutside()) {
      els.root.setAttribute("data-state", "cargo");
      els.address.textContent = state.city + " · Diğer bölgeler";
      els.note.textContent = "Bu adres aynı gün kurye bölgemizin dışında. Kargoyla gönderilebilen ürünleri görüyorsunuz.";
      return;
    }

    var parts = [state.city, state.district];
    if (state.neighborhood && state.neighborhood !== "*") parts.push(state.neighborhood);
    els.address.textContent = parts.join(" / ");

    if (anyCourier) {
      // Kurye çıkıyorsa ek açıklama yazmıyoruz: yeşil kart ve ürünlerdeki
      // rozetler zaten bunu söylüyor, tekrar etmek gürültü.
      els.root.setAttribute("data-state", "courier");
      els.note.textContent = "";
    } else {
      els.root.setAttribute("data-state", "cargo");
      els.note.textContent = "Bu adrese aynı gün kurye çıkmıyor, siparişiniz kargo ile gönderilir.";
    }
  }

  function refresh() {
    return loadVendorCoverage().then(function () {
      renderBar();
      applyToProducts();
    });
  }

  // ------------------------------------------------------------ adres seçici

  /**
   * Adres seçimi SİTENİN KENDİ ekranıyla yapılıyor - AGT teslimat
   * uygulamasının açtığı modal (#local-delivery-modal-overlay).
   *
   * Neden burada ayrı bir seçici yok: müşteri adresini iki farklı ekranla
   * seçerse iki farklı davranış öğrenir. Üstelik o ekran sepette ürün varken
   * "adresi değiştirmek için sepeti boşaltmanız gerekiyor" kuralını da
   * uyguluyor; kendi seçicimiz o kuralı atlardı.
   *
   * Yüzen rozete tıklıyoruz (gizli olsa bile .click() dinleyiciyi çalıştırır),
   * çünkü sepet kontrolü o dinleyicinin içinde.
   */
  function openPicker() {
    var badge = document.getElementById("local-delivery-float-badge");

    if (badge) {
      badge.click();
      return;
    }

    // Rozet yoksa (uygulama gömülüsü kapalıysa) doğrudan modalı açmayı dene.
    var overlay = document.getElementById("local-delivery-modal-overlay");

    if (overlay) {
      overlay.classList.add("active");
      return;
    }

    console.warn("Teslimat adresi ekranı bulunamadı: AGT uygulama gömülüsü açık mı?");
  }

  // -------------------------------------------------------------- başlatıcı

  function bind() {
    els.root = document.querySelector(".tm-db");
    if (!els.root) return false;

    els.label = els.root.querySelector(".tm-db__label");
    els.address = els.root.querySelector(".tm-db__address");
    els.note = els.root.querySelector(".tm-db__note");
    els.change = els.root.querySelector(".tm-db__change");

    els.change.addEventListener("click", openPicker);
    els.card = els.root.querySelector(".tm-db__card");
    els.card.addEventListener("click", function (e) {
      // Kartın herhangi bir yerine tıklamak da adres ekranını açsın -
      // mobilde küçük butonu bulmak zor.
      if (e.target !== els.change) openPicker();
    });

    return true;
  }

  function init() {
    if (!bind()) return;

    state.city = read(STORE_CITY);
    state.district = read(STORE_DISTRICT);
    state.neighborhood = read(STORE_NEIGHBORHOOD);

    // Gizleme yönetici ayarından açılıp kapatılıyor; müşteriye anahtar
    // gösterilmiyor.
    state.filterOn = els.root.getAttribute("data-filter-default") !== "off";

    collectProducts();
    renderBar();
    refresh();

    // Adres ürün sayfasındaki widget'tan değiştirilirse burayı da tazele.
    document.addEventListener("localDeliveryLocationChanged", function (e) {
      if (e.detail && e.detail.source === "tm-delivery-bar") return;

      state.city = read(STORE_CITY);
      state.district = read(STORE_DISTRICT);
      state.neighborhood = read(STORE_NEIGHBORHOOD);
      refresh();
    });

    // Sonsuz kaydırma / "daha fazla yükle" ile gelen kartlar da süzülmeli.
    var grid = document.querySelector("#collectionPr");
    if (grid && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () {
          collectProducts();
          applyToProducts();
        }, 120);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
